import { __awaiter, __generator } from "tslib";
// import { fetchProductPrice } from '@gn-audio/core';
import { fetchGroupImages, fetchGroupService } from '@gn-audio/core/api/product-catalogue';
import { ServiceType } from '@gn-audio/core/api/product-catalogue/enums/service-type';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
// import { CssClass } from '@gn-audio/core/common/enums';
import { createElement } from '@gn-audio/core/common/templating';
import { giftWrappingConfigEndpoint } from '../../constants/gift-wrapping-config-endpoint';
import './basket-gift-wrapping-item.component.scss';
import template from './basket-gift-wrapping-item.component.html';
var BasketGiftWrappingItemComponent = /** @class */ (function () {
    function BasketGiftWrappingItemComponent() {
        var _this = this;
        this.removeGiftWrapping = function () {
            var giftWrappingAddedHeadline = _this.element.querySelector(".basket-gift-wrapping-item__added-headline");
            var giftWrappingToAddHeadline = _this.element.querySelector(".basket-gift-wrapping-item__to-add-headline");
            giftWrappingAddedHeadline.style.display = 'none';
            giftWrappingToAddHeadline.style.display = 'block';
            _this.buttonDown.removeEventListener('click', _this.showGiftWrappingInfo);
            _this.buttonUp.removeEventListener('click', _this.hideGiftWrappingInfo);
            var item_id = _this.giftWrappingItem.item_id;
            _this.eventBus.post("remove-from-basket" /* BasketEvent.RemoveFromBasket */, item_id);
        };
        this.applyGiftWrapping = function () {
            var _a = _this.productItem, item_id = _a.item_id, quantity = _a.quantity;
            _this.eventBus.post("set-service-value" /* BasketEvent.SetServiceValue */, item_id, quantity, _this.giftWrappingSku, _this.giftWrappingMessage);
        };
        this.showGiftWrappingInfo = function () {
            _this.buttonDown.style.display = "none";
            _this.buttonUp.style.display = "block";
            _this.giftWrappingInfo.style.display = "block";
        };
        this.hideGiftWrappingInfo = function () {
            _this.buttonDown.style.display = "block";
            _this.buttonUp.style.display = "none";
            _this.giftWrappingInfo.style.display = "none";
        };
    }
    BasketGiftWrappingItemComponent.prototype.render = function (_a) {
        var _b;
        var eventBus = _a.eventBus, container = _a.container, data = _a.data, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.eventBus = eventBus;
                this.productItem = data.product;
                this.giftWrappingItem = data.service;
                this.giftWrappingSku = data.serviceSku;
                // Prices will only be used for special types of Gift wrapping like Black Friday, Christmas etc.
                // if (!this.giftWrappingItem) {
                //   await this.getGiftWrappingPrice();
                // }
                // this.initInfoPrice();
                this.element = createElement(template, (_b = this.giftWrappingItem) !== null && _b !== void 0 ? _b : this.giftWrapping, translations);
                container.insertAdjacentElement('beforeend', this.element);
                this.addAction = this.element.querySelector('.basket-gift-wrapping-item__action.add');
                this.removeAction = this.element.querySelector('.basket-gift-wrapping-item__action.remove');
                if (!!this.giftWrappingItem) {
                    this.removeAction.classList.add('visible');
                    this.changeHeadline();
                }
                else {
                    this.addAction.classList.add('visible');
                }
                this.setImage();
                this.setGiftWrappingMessage();
                this.addAction.addEventListener('click', this.applyGiftWrapping);
                this.removeAction.addEventListener('click', this.removeGiftWrapping);
                this.buttonDown = this.element.querySelector(".basket-gift-wrapping-item__button-down");
                this.buttonUp = this.element.querySelector(".basket-gift-wrapping-item__button-up");
                this.giftWrappingInfo = this.element.querySelector(".basket-gift-wrapping-item__infobox");
                this.buttonDown.addEventListener('click', this.showGiftWrappingInfo);
                this.buttonUp.addEventListener('click', this.hideGiftWrappingInfo);
                return [2 /*return*/];
            });
        });
    };
    // private initInfoPrice() {
    //   // Processes price UI elements and sets discount if it's applied to the gift wrapping
    //   if (this.giftWrappingItem) {
    //     const { price, price_after_item_discount } = this.giftWrappingItem;
    //     if (this.isDiscounted(price, price_after_item_discount)) {
    //       this.addDiscountedClasses();
    //     }
    //   } else if (this.giftWrapping && this.isDiscounted(this.giftWrapping.c_listedPrice, this.giftWrapping.c_discountedPrice)) {
    //     this.addDiscountedClasses();
    //   }
    // }
    // private isDiscounted = (price: number, priceAfterDiscount: number): boolean => price !== priceAfterDiscount;
    // private addDiscountedClasses = () => {
    //   this.element.querySelector('.basket-gift-wrapping-item__price--listed')
    //     .classList
    //     .add(CssClass.Discounted);
    //   this.element.querySelector('.basket-gift-wrapping-item__price--sales')
    //     .classList
    //     .add('visible');
    // }
    BasketGiftWrappingItemComponent.prototype.destroy = function () {
        var _a;
        this.addAction.removeEventListener('click', this.applyGiftWrapping);
        this.removeAction.removeEventListener('click', this.removeGiftWrapping);
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
    };
    BasketGiftWrappingItemComponent.prototype.setGiftWrappingMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var giftWrappingSitecoreConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiftWrappingSitecoreConfig()];
                    case 1:
                        giftWrappingSitecoreConfig = _a.sent();
                        this.giftWrappingMessage = giftWrappingSitecoreConfig.giftWrappingD365String;
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketGiftWrappingItemComponent.prototype.changeHeadline = function () {
        var giftWrappingAddedHeadline = this.element.querySelector(".basket-gift-wrapping-item__added-headline");
        var giftWrappingToAddHeadline = this.element.querySelector(".basket-gift-wrapping-item__to-add-headline");
        giftWrappingAddedHeadline.style.display = 'block';
        giftWrappingToAddHeadline.style.display = 'none';
    };
    BasketGiftWrappingItemComponent.prototype.setImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var imageElement, giftWrappingGroup, giftWrappingImages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageElement = this.element.querySelector(".basket-gift-wrapping-item__infobox-image");
                        return [4 /*yield*/, this.getGiftWrappingFromProductId()];
                    case 1:
                        giftWrappingGroup = _a.sent();
                        return [4 /*yield*/, fetchGroupImages(giftWrappingGroup.groupId)];
                    case 2:
                        giftWrappingImages = _a.sent();
                        if (!(giftWrappingImages === null || giftWrappingImages === void 0 ? void 0 : giftWrappingImages.length)) {
                            this.setGiftWrappingDefaultImage(imageElement);
                            return [2 /*return*/];
                        }
                        imageElement.src = giftWrappingImages[0].url;
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketGiftWrappingItemComponent.prototype.getGiftWrappingFromProductId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, groupId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchProductsBySkus([this.productItem.product_id])];
                    case 1:
                        products = _a.sent();
                        groupId = products[0].groupId;
                        return [4 /*yield*/, fetchGroupService(groupId, ServiceType.GiftWrapping)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // private async getGiftWrappingPrice() {
    //   const giftWrappingGroup = await this.getGiftWrappingFromProductId();
    //   this.giftWrapping = await fetchProductPrice(giftWrappingGroup.productId);
    //   this.giftWrapping.c_price_formatted = this.giftWrapping.c_formattedListedPrice;
    //   this.giftWrapping.c_price_after_item_discount_formatted = this.giftWrapping.c_formattedDiscountedPrice;
    // }
    BasketGiftWrappingItemComponent.prototype.setGiftWrappingDefaultImage = function (imageElement) {
        return __awaiter(this, void 0, void 0, function () {
            var giftWrappingSitecoreConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiftWrappingSitecoreConfig()];
                    case 1:
                        giftWrappingSitecoreConfig = _a.sent();
                        imageElement.src = giftWrappingSitecoreConfig.giftWrappingFallbackImage;
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketGiftWrappingItemComponent.prototype.getGiftWrappingSitecoreConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var giftWrappingSitecoreResponse, giftWrappingSitecoreConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(giftWrappingConfigEndpoint)];
                    case 1:
                        giftWrappingSitecoreResponse = _a.sent();
                        return [4 /*yield*/, giftWrappingSitecoreResponse.json()];
                    case 2:
                        giftWrappingSitecoreConfig = _a.sent();
                        return [2 /*return*/, giftWrappingSitecoreConfig];
                }
            });
        });
    };
    BasketGiftWrappingItemComponent.$inject = [];
    return BasketGiftWrappingItemComponent;
}());
export { BasketGiftWrappingItemComponent };
